'use client';

import { RecaptchaProvider } from '@/components/shared/RecaptchaProvider';
import Newsletter from './Newsletter';

interface Props {
  companyId: string;
  domain: string;
}

const NewsletterWrapper = ({ companyId, domain }: Props) => {
  return (
    <RecaptchaProvider domain={domain}>
      <Newsletter companyId={companyId} domain={domain} />
    </RecaptchaProvider>
  );
};

export default NewsletterWrapper;
